import { StarterDashboardV2BreakpointStateContext } from './context';
import { useBreakpointState } from './hook';

export function StarterDashboardV2BreakpointStateProvider({ children }: { children: React.ReactNode }): JSX.Element {
	const breakpointState = useBreakpointState();

	return (
		<StarterDashboardV2BreakpointStateContext.Provider value={breakpointState.data}>
			{children}
		</StarterDashboardV2BreakpointStateContext.Provider>
	);
}
